import { render } from "./product.vue?vue&type=template&id=20956939&scoped=true"
import script from "./product.vue?vue&type=script&lang=js"
export * from "./product.vue?vue&type=script&lang=js"

import "./product.vue?vue&type=style&index=0&id=20956939&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-20956939"

export default script